import Home from './Home.vue';
import intro from './intro.vue';
import guidanceForm from './guidanceForm.vue';
import formSummary from './formSummary.vue';
import share from './share.vue';
import privacyStatement from './privacyStatement.vue';

export default {
    Home,
    intro,
    guidanceForm,
    formSummary,
    share,
    privacyStatement
}
